import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { POSTHOG_HOST, POSTHOG_KEY } from '../../../constants';

const RemoteMetricsProvider = ({ children }) => {
  const enabled = process.env.REACT_APP_REMOTE_METRICS_ENABLED === 'true';
  if (!enabled) {
    return <>{children}</>;
  }
  const apiKey = POSTHOG_KEY
  const apiHost = POSTHOG_HOST;

  // If no API key is configured, render children without metrics
  if (!apiKey || !apiHost) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        api_host: apiHost,
        defaults: '2025-05-24',
        capture_exceptions: true,
      }}
    >
      {children}
    </PostHogProvider>
  );
};

export { RemoteMetricsProvider };
